module.exports = __webpack_public_path__ + "img/Comoros.a5fadf50.png";